module.exports = __webpack_public_path__ + "static/media/gu.64936a10.svg";